import * as React from "react";
import MobileComplete from "./components/mobile-complete";
import Webomplete from "./components/web-complete";
import { useOutletContext } from "react-router-dom";

export default function Complete() {
	const [handleChangeWebStyleLayout, layout] = useOutletContext();

	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileComplete />
				: <Webomplete onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
